import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { QuickChatComponent } from 'app/fuse-template/layout/common/quick-chat/quick-chat.component';
import { SharedModule } from 'app/fuse-template/shared/shared.module';

@NgModule({
    declarations: [QuickChatComponent],
    imports: [
        FuseDrawerComponent,
        FuseScrollbarDirective,
        RouterModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        SharedModule,
    ],
    exports: [QuickChatComponent],
})
export class QuickChatModule {}
